export default __webpack_public_path__ + "static/media/React.7405464d.png";